'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deprecated(propType, message, defaultValue) {
  var deprecatedPropType = function deprecatedPropType(props, propName, componentName, location) {
    for (var _len = arguments.length, rest = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    var propValue = props[propName];
    var output = typeof message === 'function' ? message(propName, propValue, props) : message;

    if (output && propValue !== defaultValue) {
      _devLogger2.default.warn(output);
    }

    return propType.apply(undefined, [props, propName, componentName, location].concat(rest));
  };

  var wrappedIntrospection = propType.__INTROSPECTION__ || {};

  deprecatedPropType.__INTROSPECTION__ = _extends({}, wrappedIntrospection, {
    deprecated: true
  });

  return deprecatedPropType;
}

exports.default = deprecated;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/utils/propTypes/deprecated.js
// module id = 368
// module chunks = 0